import { render, staticRenderFns } from "./TenderDownloadsPage.vue?vue&type=template&id=69216da8&"
import script from "./TenderDownloadsPage.vue?vue&type=script&lang=js&"
export * from "./TenderDownloadsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports